export const contrast = function contrast(color) {
  const rgb = color.replace(/[^\d,]/g, '').split(',');
	let C = [ rgb[0]/255, rgb[1]/255, rgb[2]/255 ];
	for ( var i = 0; i < C.length; ++i ) {
		if ( C[i] <= 0.03928 ) {
			C[i] /= 12.92;
		} else {
			C[i] = Math.pow( ( C[i] + 0.055 ) / 1.055, 2.4);
		}
	}

	const L = 0.2126 * C[0] + 0.7152 * C[1] + 0.0722 * C[2];
	if ( L > 0.179 ) {
		return 'rgba(31,45,61,0.7)'
	} else {
    return 'rgba(255, 255, 255, 0.7)'
	}
}

function convertHexToRGB(color) {
  if (color.length === 4) {
    let extendedColor = '#';
    for (let i = 1; i < color.length; i++) {
      extendedColor += color.charAt(i) + color.charAt(i);
    }
    color = extendedColor;
  }

  const values = {
    r:	parseInt(color.substr(1, 2), 16),
    g:	parseInt(color.substr(3, 2), 16),
    b:	parseInt(color.substr(5, 2), 16),
  };

  return `rgb(${values.r}, ${values.g}, ${values.b})`;
}

export const contrastFromHex = function contrastFromHex(hex) {
  let color = convertHexToRGB(hex);
  const rgb = color.replace(/[^\d,]/g, '').split(',');
	let C = [ rgb[0]/255, rgb[1]/255, rgb[2]/255 ];
	for ( var i = 0; i < C.length; ++i ) {
		if ( C[i] <= 0.03928 ) {
			C[i] /= 12.92;
		} else {
			C[i] = Math.pow( ( C[i] + 0.055 ) / 1.055, 2.4);
		}
	}

	const L = 0.2126 * C[0] + 0.7152 * C[1] + 0.0722 * C[2];
	if ( L > 0.179 ) {
		return 'rgba(31,45,61,0.7)'
	} else {
    return 'rgba(255, 255, 255, 0.7)'
	}
}



// WEBPACK FOOTER //
// ./src/helpers/colors.js